import { useState } from 'react'
import { Check, Loader2 } from 'lucide-react'

interface Props {
  sku: string
  initial: number
  onSave: (sku: string, price: number) => Promise<void>
}

/** Inline-Edit eines Entwurfs-VK (price_draft) für eine Vorschau-Zeile. */
export function DraftPriceCell({ sku, initial, onSave }: Props) {
  const [value, setValue] = useState<string>(String(initial))
  const [saving, setSaving] = useState(false)

  async function commit() {
    const num = Number(value)
    if (Number.isNaN(num)) return
    setSaving(true)
    try {
      await onSave(sku, num)
    } catch {
      // Fehler-Toast kommt aus dem onSave-Handler (saveDraft.onError); hier nur State-Reset.
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="inline-flex items-center gap-1 justify-end">
      <input
        type="number"
        step="0.01"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); void commit() } }}
        disabled={saving}
        className="w-24 px-2 py-1 text-sm text-right rounded border border-line bg-background font-mono outline-none focus:border-primary"
      />
      <button
        onClick={() => void commit()}
        disabled={saving}
        title="Entwurf übernehmen"
        aria-label="Entwurf übernehmen"
        className="inline-flex items-center justify-center size-7 rounded bg-primary text-primary-foreground hover:opacity-90 disabled:opacity-50"
      >
        {saving ? <Loader2 className="size-3.5 animate-spin" /> : <Check className="size-3.5" />}
      </button>
    </div>
  )
}
